import { Component, inject, input } from '@angular/core';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IconService } from '@unity/services/icon.service';
import { LinkSharedComponent, LinkVariant } from '@unity/shared/composed/link-shared/link-shared.component';
import { UnityRouteUrlTrees } from '@unity/utils/types';

@Component({
  selector: 'unity-link-gridcell-shared',
  standalone: true,
  imports: [IconsModule, LinkSharedComponent],
  templateUrl: './link-gridcell-shared.component.html',
  styleUrl: './link-gridcell-shared.component.scss',
})
export class LinkGridcellSharedComponent {
  private readonly iconService = inject(IconService);
  protected envelopeIcon = this.iconService.envelopeIcon;

  public readonly $displayText = input.required<string>({ alias: 'displayText' });
  public readonly $link = input.required<UnityRouteUrlTrees>({ alias: 'link' });
  public readonly $variants = input<LinkVariant[]>([], { alias: 'variants' });
}
